export default __webpack_public_path__ + "7d9b3e95d300d35996abc16cd2af79af.png";